import gql from 'graphql-tag'
import {fragmentUserList} from './user'

export const queryExplore = gql`
	query explore($offset: Int, $limit: Int) {
		explore(offset: $offset, limit: $limit) {
			pagination {
				offset
				limit
				total
			}
			edges {
				id
				adventure {
					id
					title
				}
				fotos {
					id
					image {
						id
						uri(type: SQUARE)
					}
				}
			}
		}
	}
`

export const querySearch = gql`
	query search($keyword: String!) {
		search(keyword: $keyword) {
			adventures {
				id
				title
				description
				author {
					id
					fullname
				}
			}
			users {
				...UserList
			}
		}
	}
	${fragmentUserList}
`
